import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

// Redux Actions
import { nextStep, previousStep } from './../redux/step'
import { setVehicleInfo, setAppointmentInfo, removeForm } from './../redux/form'
import { setVehicle as setVehicleRedux, removeVehicle } from './../redux/vehicle'
import { removeCustomer } from './../redux/customer'
import { removeVehicles } from './../redux/vehicles'
import { removeFormerDealer } from './../redux/formerDealer'
import { removeTimeSlots } from './../redux/timeSlots'
import { setVehicleModel as setVehicleModelRedux } from './../redux/form'

// MUI
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField'
import Checkbox from '@mui/material/Checkbox'
import Typography from '@mui/material/Typography'
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import InputAdornment from '@mui/material/InputAdornment';
import Autocomplete from '@mui/material/Autocomplete';

// MUI Icons
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import ErrorIcon from '@mui/icons-material/Error';
import MicIcon from '@mui/icons-material/Mic';
import StopIcon from '@mui/icons-material/Stop';

//
// Utils
import { plateSplitter, numberWithSeperators } from "../util/helper";
import { isRenault, GOOGLE_API_KEY, LOGO, MODELS } from "../util/constants";
import useSpeechToText from 'react-hook-speech-to-text';

// Custom
import CustomCard from "../components/CustomCard";
import CustomFormLabel from '../components/CustomFormLabel';

import { NumericFormat } from 'react-number-format';

// Custom number format
function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;
    return (
        <NumericFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target:
                        { name: props.name, value: values.value }
                });
            }}
            thousandSeparator='.'
            decimalSeparator=','
        />);
}


// Spacing
const spacingRoot = { xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }

function FunctionalComponent(props) {

    // Props
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const appointmentNoteCategoryParents = useSelector(state => state.appointmentNotes)
    const portLogin = useSelector(state => state.portLogin)
    const vehicles = useSelector(state => state.vehicles)
    const form = useSelector(state => state.form)
    // const vehicleModel = useSelector(state => state.vehicleModel)

    const theme = useTheme()
    // Styles
    const styles = {
        formRoot: {
            width: '100%',
        },
        formControl: {
        },
        checkboxChecked: {
            color: theme.palette.success.main,
        },
        micButtonRoot: {
            color: theme.palette.error.main,
        },
    }

    // Media query screen size
    const xsDown = useMediaQuery(theme.breakpoints.down('sm'));
    const smDown = useMediaQuery(theme.breakpoints.down('md'));
    const mdDown = useMediaQuery(theme.breakpoints.down('lg'));
    const lgDown = useMediaQuery(theme.breakpoints.down('xl'));
    const xlDown = useMediaQuery(theme.breakpoints.down('xl'));

    // Calculate spacing 
    const spacingForm = useMemo(() => {

        // const spacings = { xs: 2, sm: 2, md: 3, lg: 3, xl: 4 }
        const spacings = { xs: 0, sm: 0, md: 0, lg: 0, xl: 0 }

        if (xsDown) {
            return spacings.xs
        }
        else {
            if (smDown) {
                return spacings.sm
            }
            else {
                if (mdDown) {
                    return spacings.md
                }
                else {
                    if (lgDown) {
                        return spacings.lg
                    }
                    else {
                        if (xlDown) {
                            return spacings.xl
                        }
                        else {
                            return spacings.xl
                        }
                    }
                }
            }
        }

    }, [xsDown, smDown, mdDown, lgDown, xlDown]);

    // Loading
    const [loading, setLoading] = useState(false);

    // Forms
    const [km, setKm] = useState(form.km);
    const [maintenance, setMaintenance] = useState(form.maintenance);
    const [vale, setVale] = useState(form.vale);
    const [appointmentRequests, setAppointmentRequests] = useState(form.appointmentRequests);
    const [appointmentRequesInputValue, setAppointmentRequesInputValue] = useState('');
    const [vehicle, setVehicle] = useState('');
    const [vehicleModel, setVehicleModel] = useState('');

    // Form error states
    const [kmError, setKmError] = useState(false);
    const [vehicleError, setVehicleError] = useState(false);
    const [appointmentRequestsError, setAppointmentRequestsError] = useState(false);

    const [nextButton, setNextButtonColor] = useState('inherit');




    useEffect(() => {
        if (portLogin) {
            if (form.vehicle) {
                setVehicle(form.vehicle)
            }
            else {
                if (vehicles.length > 0) setVehicle(vehicles[0])
            }
        } else {
            if (form.vehicleModel) {
                setVehicleModel(form.vehicleModel)
            }
        }

        return () => {
            // Clean up
        }
    }, [])

    // On moun
    //GA DataLayer
    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'formSteps',
            'pageName': isRenault ? 'Renault_Servis_Randevusu' : 'Dacia_Servis_Randevusu',
            'businessType': 'after-sales',
            'pageType': 'form',
            'formName': 'Online Servis Randevusu',
            'formType': 'service-request',
            'formCategory': 'lead-after-sales',
            'formStepName': 'step-1',
            'formStepNumber': 'step-1',
            'vehicleId': form.vehicleId,
            'vehicleModel': form.vehicleModel

        });

    }, [])



    // On maintenance change
    useEffect(() => {
        if (maintenance) {
            const temp = appointmentRequests.filter(f => f.id !== 'maintenance')
            let kmwithSeperator = numberWithSeperators(km)
            setAppointmentRequests([...temp, { id: 'maintenance', note: `${kmwithSeperator} km'de bakım yaptırmak istiyor`, key: 'maintenance' }])
            setAppointmentRequestsError(false)
        }
        else {
            setAppointmentRequests(appointmentRequests.filter(f => f.id !== 'maintenance'))
        }
    }, [maintenance, km])

    useEffect(() => {
        if (appointmentRequests.length > 0) {
            setNextButtonColor('secondary');
        } else {
            setNextButtonColor('inherit');
        }
    }, [appointmentRequests]);

    // Previous step
    function handleBackButton() {

        // Clear redux
        dispatch(removeFormerDealer())
        dispatch(removeVehicles())
        dispatch(removeCustomer())
        dispatch(removeVehicle())
        dispatch(removeForm())
        dispatch(removeTimeSlots())

        // Go previous step
        dispatch(previousStep())
    }

    // Next step
    function handleNextStep() {
        // window.dataLayer.push({
        //     pageName: 'Renault_Servis_Randevusu',
        //     pageType: 'form',
        // });

        if (loading) { return }

        // Form validation
        let error = false;
        if (!portLogin && !vehicleModel) {
            setVehicleError(true)
            error = true
        }
        else if (portLogin && !vehicle) {
            setVehicleError(true)
            error = true
        }
        if (appointmentRequests.length === 0) {
            setAppointmentRequestsError(true)
            error = true
        }

        // Don't proceed if there is an error 
        if (!error) {
            if (portLogin) dispatch(setVehicleRedux(vehicle))

            if (vehicle != null && vehicle.chassisId != null) {
                dispatch(setVehicleInfo(vehicle.chassisId))
            }

            // Save vehicle model
            dispatch(setVehicleModelRedux(vehicleModel))

            dispatch(setAppointmentInfo({
                km,
                vale,
                appointmentRequests,
                maintenance
            }))



            dispatch(nextStep())
        }
    }

    function getMenuItemContent(vehicle) {
        return (
            <Box display='flex' justifyContent='flex-start' alignItems='center' width={1}>
                <Box pr={1}>
                    {vehicle.modelName}
                </Box>
                <Box pr={1} color="text.secondary">
                    {plateSplitter(vehicle.plate)}
                </Box>
            </Box>
        )
    }

    const {
        error,
        isRecording,
        results,
        startSpeechToText,
        stopSpeechToText,
    } = useSpeechToText({
        continuous: false,
        timeout: 10000,
        crossBrowser: true,
        googleApiKey: GOOGLE_API_KEY,
        googleCloudRecognitionConfig: {
            languageCode: 'tr'
        },
        speechRecognitionProperties: {
            lang: 'tr',
            interimResults: true // Allows for displaying real-time speech results
        }
    });


    // On speach results change
    useEffect(() => {
        if (results.length > 0) {
            setAppointmentRequests([...appointmentRequests, { id: '', note: results[results.length - 1] }])
            setAppointmentRequestsError(false)
        }
    }, [results])

    function getCardContent() {
        return (
            <Grid container spacing={spacingForm}>
                <Grid item xs={12} sm={12} md={12}>
                    <Typography variant='h6' align='center'>
                        Servis Hizmetlerini Girin
                    </Typography>
                </Grid>
                <Box m={1} />
                <form className={styles.formRoot} noValidate autoComplete="off">
                    <Grid container spacing={spacingForm}>

                        {/* Select vehicle */}
                        {
                            portLogin &&
                            <Grid item xs={12}>
                                <FormControl
                                    variant='outlined'
                                    fullWidth
                                    sx={styles.formControl}
                                    error={vehicleError}
                                >
                                    <InputLabel>{t('vehicle')}</InputLabel>
                                    <Select
                                        value={vehicle}
                                        onChange={e => {
                                            setVehicle(e.target.value);
                                            if (e.target.value) setVehicleError(false)
                                        }}
                                        label={t('vehicle')}
                                    >
                                        {
                                            vehicles.map((vehicle, i) =>

                                                <MenuItem key={vehicle.id} value={vehicle}>{getMenuItemContent(vehicle)}</MenuItem>

                                            )
                                        }
                                        <MenuItem style={{ display: 'none' }} value={''}></MenuItem>
                                    </Select>
                                    <FormHelperText >{vehicleError ? t('vehicleError') : ''}</FormHelperText>
                                </FormControl>
                            </Grid>
                        }

                        { /* vehicleModel null */}
                        {!portLogin &&

                            <Grid item xs={12}>
                                {/* <TextField
                                    label={t('vehilceModel')}
                                    fullWidth
                                    variant='outlined'
                                    value={vehicleModel}
                                    onChange={e => {
                                        setVehicleModel(e.target.value);
                                    }}
                                /> */}
                                <CustomFormLabel content={t('vehicleModel')} />
                                <Grid item container xs={12} direction="row" style={{ position: "relative" }}>
                                    <Autocomplete
                                        style={{ marginTop: '5px' }}
                                        fullWidth
                                        disableClearable
                                        options={MODELS}
                                        getOptionLabel={(option) => option}
                                        value={vehicleModel}

                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                fullWidth
                                                helperText={vehicleError ? t('vehicleError') : null}
                                                FormHelperTextProps={{ error: vehicleError }}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    startAdornment: <InputAdornment position="start">{<img src={theme.palette.mode === 'dark' ? LOGO.WHITE : LOGO.BLACK} alt="logo" style={{ width: isRenault ? '23px' : '55px', height: '28px' }} />}</InputAdornment>,
                                                    // endAdornment: vehicleError ? <InputAdornment position='end'><ErrorIcon color='error' /></InputAdornment> : null,

                                                }} />
                                        }
                                        onInputChange={(e, newInputValue) => {
                                            if (e) {
                                                var modelExist = MODELS.includes(newInputValue)
                                                if (modelExist) {
                                                    setVehicleModel(newInputValue);
                                                    setVehicleError(false)
                                                }
                                                else {
                                                    setVehicleModel('');
                                                }
                                            }
                                        }}

                                    />

                                </Grid>
                            </Grid>
                        }

                        {/* Km */}
                        <Grid item xs={12}>
                            <CustomFormLabel content={t('km')} />
                            <TextField
                                style={{ marginTop: '5px' }}
                                error={kmError}
                                helperText={kmError ? t('kmError') : null}
                                FormHelperTextProps={{ error: kmError }}
                                fullWidth
                                variant='outlined'
                                InputProps={{
                                    endAdornment: kmError ? <InputAdornment position='end'><ErrorIcon color='error' /></InputAdornment> : <InputAdornment position="end">KM</InputAdornment>,
                                    inputComponent: NumberFormatCustom
                                }}
                                value={km}
                                onChange={e => {
                                    setKm(Math.abs(e.target.value));
                                    setKmError(false)
                                    if (!e.target.value && maintenance) {
                                        setMaintenance(false)
                                    }
                                }}
                            />
                        </Grid>

                        {/* Maintenance */}
                        <Grid item xs={12}>
                            <Box display='flex' alignItems='center' ml='-11px'>
                                <Checkbox
                                    checked={maintenance}
                                    onChange={e => {
                                        if (!km) {
                                            setKmError(true)
                                        }
                                        else {
                                            setMaintenance(e.target.checked)
                                        }
                                    }}
                                    color='default'
                                    sx={{ '&.Mui-checked': styles.checkboxChecked }}
                                />
                                <Typography variant='body1' >{t('maintenance')}</Typography>
                            </Box>
                        </Grid>

                        {/* Vale */}
                        <Grid item xs={12}>
                            <Box display='flex' alignItems='center' ml='-11px'>
                                <Checkbox
                                    checked={vale}
                                    onChange={e => {
                                        setVale(e.target.checked)
                                    }}
                                    color='default'
                                    sx={{ '&.Mui-checked': styles.checkboxChecked }}
                                />
                                <Typography variant='body1' >{t('vale')}</Typography>
                            </Box>
                            <Typography variant='body2' color='textSecondary'>{t('valeDescription')}</Typography>
                        </Grid>

                        {/* Appointment Requests */}
                        <Grid item container spacing={0} xs={12}>

                            {/* Appoinment Requests Title */}
                            <Grid item xs={12}>
                                <Typography variant='h6' >
                                    {t('appointmentRequestsTitle')}
                                </Typography>
                            </Grid>

                            {/* Form Error */}
                            {
                                appointmentRequestsError &&
                                <Grid item xs={12}>
                                    <Box w={1} alignItems='center'>
                                        <Typography variant='body2' color='error'>{`${t('appointmentRequestsError')}`}</Typography>
                                    </Box>
                                </Grid>
                            }

                            {/* set valet operation */}
                            {
                                vale &&
                                <Grid key='valet' item xs={12} container alignItems='center' justifyContent='space-between' wrap='nowrap'>
                                    <Box>
                                        <Typography variant='body1' color='textSecondary'>{`${t('requestVale')}`}</Typography>
                                    </Box>
                                    <Box>
                                        <IconButton
                                            onClick={() => {
                                                setVale(false)
                                            }}
                                            size="large">
                                            <DeleteIcon />
                                        </IconButton>
                                    </Box>
                                </Grid>
                            }

                            {/* Selected Appointment Requests */}
                            {
                                appointmentRequests.map((appointmentRequest, idx) => (
                                    <Grid key={appointmentRequest.id + appointmentRequest.note + idx} item xs={12} container alignItems='center' justifyContent='space-between' wrap='nowrap'>
                                        <Box>
                                            <Typography variant='body1' color='textSecondary'>{appointmentRequest.note}</Typography>
                                        </Box>
                                        <Box>
                                            <IconButton
                                                onClick={() => {
                                                    if (appointmentRequest.id === 'maintenance') setMaintenance(false)
                                                    setAppointmentRequests(appointmentRequests.filter(f => !(f.id === appointmentRequest.id && f.note === appointmentRequest.note)))
                                                }}
                                                size="large">
                                                <DeleteIcon />
                                            </IconButton>
                                        </Box>
                                    </Grid>
                                ))
                            }

                            {/* Appoinment Requests Combobox */}
                            {
                                true &&
                                <Grid item xs={12} container alignItems='center' wrap='nowrap' >

                                    {/* Search Field */}
                                    <Autocomplete
                                        fullWidth
                                        freeSolo
                                        disableClearable
                                        options={[]}
                                        getOptionLabel={(option) => option.note}
                                        renderInput={(params) => <TextField {...params} variant="outlined" />}
                                        inputValue={appointmentRequesInputValue}
                                        onInputChange={(event, newInputValue) => {
                                            setAppointmentRequesInputValue(newInputValue);
                                        }}
                                    />

                                    {/* Add Button */}
                                    <Box pl={1} >
                                        <IconButton
                                            onClick={() => {
                                                if (!appointmentRequesInputValue) return
                                                const appointmentNoteCategoryParent = appointmentNoteCategoryParents.find(n => n.note === appointmentRequesInputValue)
                                                if (appointmentNoteCategoryParent) {
                                                    setAppointmentRequests([...appointmentRequests, appointmentNoteCategoryParent])
                                                }
                                                else {
                                                    setAppointmentRequests([...appointmentRequests, { id: '', note: appointmentRequesInputValue }])
                                                }
                                                setAppointmentRequestsError(false)
                                                setAppointmentRequesInputValue('')
                                            }}
                                            size="large">
                                            <AddIcon />
                                        </IconButton>
                                    </Box>

                                </Grid>
                            }

                            {/* Mic */}
                            <Grid item xs={12}>
                                <Box display='flex' justifyContent='flex-end' alignItems='center' width={1} pt={1}>

                                    {/* Mic Status */}
                                    {
                                        isRecording && false &&
                                        <Typography variant='body1' >{t('micRecordingText')}</Typography>
                                    }

                                    {/* Mic Button  */}
                                    <Box display='flex' alignItems='center'>

                                        {/* Button Text */}
                                        {
                                            !error ?
                                                <Typography variant='body1' >{isRecording ? t('micRecordingText') : t('micButtonText')}</Typography> :
                                                <Typography variant='body1' >{t('micErrorText')}</Typography>
                                        }

                                        <Box pl={1}>
                                            <IconButton
                                                disabled={!!error}
                                                onClick={isRecording ? stopSpeechToText : startSpeechToText}
                                                color={isRecording ? 'primary' : 'inherit'}
                                                size="large">
                                                {
                                                    isRecording ?
                                                        <StopIcon sx={isRecording ? styles.micButtonRoot : ''} /> :
                                                        <MicIcon sx={isRecording ? styles.micButtonRoot : ''} />
                                                }
                                            </IconButton>
                                        </Box>
                                    </Box>

                                </Box>
                            </Grid>

                        </Grid>

                    </Grid>
                </form>
            </Grid>
        );
    }

    function getCardActions() {
        return (
            <Box display='flex' justifyContent='space-between'>
                <Button
                    variant="contained"
                    sx={styles.button}
                    onClick={handleBackButton}
                    style={{ width: '170px', minHeight: '42px' }}
                    disableElevation
                >
                    {t('backButton')}
                </Button>
                <Button variant="contained" disableElevation color={nextButton} style={{ width: '170px', minHeight: '42px', marginLeft: '5px' }} onClick={handleNextStep}>
                    {t('nextButton')}
                </Button>
            </Box>
        )
    }

    return (
        <CustomCard
            padding={spacingRoot}
            content={getCardContent()}
            action={getCardActions()}
        />
    )
}

// Connect redux and translation
export default FunctionalComponent
